import React, { useState, useEffect } from 'react';
import './AgentDetails.css';
import axios from 'axios'; // Подключаем axios для HTTP запросов


const AgentDetails = ({ agentId, fetchTreeData, selectedNode, agentName, refreshTree, setSelectedAgentId }) => {
  const [agentData, setAgentData] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [newBranchName, setNewBranchName] = useState('');
  const [activeTab, setActiveTab] = useState('agentInfo'); // Вкладки
  const [existingParameters, setExistingParameters] = useState([]);
  const [newName, setNewName] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [newType, setNewType] = useState('');
  const [newUnit, setNewUnit] = useState('');
  const [showParamModal, setShowParamModal] = useState(false); // Убедитесь, что состояние showParamModal определено
  const [selectedParameters, setSelectedParameters] = useState([]); // Состояние для хранения выбранных параметров
  const [showNotification, setShowNotification] = useState(false);
  const [showOkpModal, setShowOkpModal] = useState(false);
  const [existingOkps, setExistingOkps] = useState([]);  // Массив всех ОКП из словаря
  const [selectedOkps, setSelectedOkps] = useState([]);  // Выбранные ОКП для агента
  const [workflows, setWorkflows] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedWorkflows, setSelectedWorkflows] = useState(new Set());
  const [processTime, setProcessTime] = useState(""); // Время начала техпроцесса
  const [processYear, setProcessYear] = useState("");
  const [processMonth, setProcessMonth] = useState("");
  const [processDay, setProcessDay] = useState("");
  const [queueNumber, setQueueNumber] = useState("");

  useEffect(() => {
    if (agentId) {
      // Если выбран агент, сбрасываем данные о ветке
      setAgentData(null); // Сбрасываем информацию о ветке, когда выбран агент
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Agents/${agentId}`)
        .then((response) => response.json())
        .then((data) => {
          setAgentData(data);
          setQuantity(data.quantity);
          setActiveTab('agentInfo'); // Активируем вкладку для агента
        })
        .catch((error) => console.error('Error loading agent data:', error));
    } else if (selectedNode) {
      // Если выбрана ветка, сбрасываем данные об агенте
      setAgentData(null); // Сбрасываем информацию об агенте, когда выбрана ветка
      setActiveTab('treeSettings'); // Активируем вкладку для ветки
    }
  }, [agentId, selectedNode]);

  useEffect(() => {
    if (agentId) {
      // Загружаем номер очереди
      fetchQueueNumber(agentId);
    }
  }, [agentId]);


  useEffect(() => {
    if (agentId) {
      // Сбрасываем состояния времени при смене агента
      setProcessYear("");
      setProcessMonth("");
      setProcessDay("");
      setProcessTime("");
  
      // Запрашиваем данные о времени начала техпроцесса
      fetchTimeStart(agentId);
    }
  }, [agentId]);

  // Запрос для получения привязанных workflow
  useEffect(() => {
    if (agentId) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/AgentWFBranchingController/agent/${agentId}/workflows`)
        .then((response) => response.json())
        .then((data) => {
          setSelectedWorkflows(new Set(data)); // Устанавливаем привязанные workflows
        })
        .catch((error) => console.error('Error loading agent workflows:', error));
    }
  }, [agentId]);
  
  useEffect(() => {
      fetchDictionaryOkps();
  }, []);
  useEffect(() => {
    fetchDictionaryParameters(); // Загружаем параметры при инициализации компонента
  }, []); // Это сработает один раз при первой загрузке компонента

  const fetchDictionaryOkps = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/OKPDictionary`);
      const data = await response.json();
      setExistingOkps(data);
    } catch (error) {
      console.error('Ошибка при получении ОКП из словаря:', error);
    }
  };
  
  const deleteAgent = async () => {
    if (!agentId) return;
  
    const confirmed = window.confirm('Вы уверены что хотите удалить агента?');
    if (!confirmed) return;
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Agents/${agentId}`, {
        method: 'DELETE',
      });
  
      if (response.ok) {
        alert('Агент успешно удален');
        setAgentData(null); // Сбрасываем данные об агенте
        setSelectedAgentId(null); // Сбрасываем выбранного агента
        setActiveTab('treeSettings'); // Переключаемся на настройки дерева
        if (refreshTree) {
          refreshTree(); // Обновляем данные дерева
        }
      } else {
        alert('Ошибка удаления агента');
      }
    } catch (error) {
      console.error('Ошибка удаления:', error);
      alert('Попробуйте удалить еще раз.');
    }
  };

  const fetchQueueNumber = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Agent/${id}/queue`);
      const { queue } = response.data;
  
      if (queue) {
        // Извлекаем номер очереди из строки
        const queueNum = queue.split(".")[1]; // Предполагается формат "agent.{номер}"
        setQueueNumber(queueNum);
      }
    } catch (error) {
      console.error("Ошибка при загрузке номера очереди:", error);
    }
  };

  // Функция для скачивания архива с файлами агента
  const fetchTimeStart = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Agent/${id}/get-timestart`);
    const { timeStart } = response.data;

    if (timeStart) {
      const [date, time] = timeStart.split(" "); // Разделяем дату и время
      const [year, month, day] = date.split("-"); // Извлекаем год, месяц, день

      setProcessYear(year);
      setProcessMonth(month);
      setProcessDay(day);
      setProcessTime(time);
    }
  } catch (error) {
    console.error("Ошибка при загрузке времени начала:", error);
  }
};
const downloadArchive = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/AgentMessages/create-archive/${agentId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Ошибка при получении архива');
    }

    const blob = await response.blob(); // Получаем ответ как Blob
    const url = window.URL.createObjectURL(blob); // Создаём URL для Blob
    const a = document.createElement('a'); // Создаём ссылку для скачивания
    a.href = url;
    a.download = `archive_${agentId}.zip`; // Имя файла для скачивания
    a.click();
    window.URL.revokeObjectURL(url); // Удаляем URL после скачивания
  } catch (error) {
    console.error('Ошибка при скачивании архива:', error);
  }
};

  const handleOkpSelection = (okpId) => {
    const selectedOkp = existingOkps.find(okp => okp.id === okpId); // Находим объект ОКП по id
    if (selectedOkps.some(okp => okp.id === okpId)) {
      // Убираем выбранный ОКП, если он уже был выбран
      setSelectedOkps(selectedOkps.filter(okp => okp.id !== okpId));
    } else {
      // Добавляем объект ОКП в массив выбранных
      setSelectedOkps([...selectedOkps, selectedOkp]);
    }
  };
  const handleSaveSelectedOkps = () => {
    // Если selectedOkps уже содержит объекты ОКП, не нужно фильтровать
    const selectedOkpObjects = selectedOkps.map(okp => ({
      okpId: okp.id, // Преобразуем объект ОКП к нужному формату
      name: okp.name,
    }));
  
    setAgentData({
      ...agentData,
      okPs: selectedOkpObjects  // Обновляем ОКП агента
    });
  
    setShowOkpModal(false);
  };
  const sendProcess = async () => {
    // Объединяем дату и время
    const formattedTimeStart = `${processYear}-${processMonth.padStart(2, '0')}-${processDay.padStart(2, '0')} ${processTime}`;
    
    // Создаем тело запроса
    const payload = {
      timeStart: processYear && processMonth && processDay && processTime ? formattedTimeStart : "",
    };
  
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/Agent/${agentId}/send-json`, payload);
      alert("Техпроцесс отправлен успешно!");
    } catch (error) {
      console.error("Ошибка отправки техпроцесса:", error);
      alert("Ошибка отправки техпроцесса!");
    }
  };
  

const handleAddNewParameter = async () => {
  if (!newName.trim() || !newDescription.trim() || !newType.trim() || !newUnit.trim()) {
    alert('Все поля должны быть заполнены.');
    return;
  }

  const newParameter = {
    name: newName,
    description: newDescription,
    type: newType,
    unit: newUnit,
  };

  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/DictionaryParameters`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newParameter),
    });

    if (!response.ok) {
      throw new Error('Ошибка при добавлении параметра в словарь');
    }
    
    const savedParameter = await response.json(); // Получаем параметр с id от сервера

    // Добавляем новый параметр в список существующих параметров
    setExistingParameters([...existingParameters, savedParameter]);

    // Очищаем поля формы
    setNewName('');
    setNewDescription('');
    setNewType('');
    setNewUnit('');
  } catch (error) {
    console.error('Ошибка при добавлении нового параметра:', error);
  }
};;
  const handleParameterSelection = (paramId) => {
    if (selectedParameters.includes(paramId)) {
      setSelectedParameters(selectedParameters.filter(id => id !== paramId)); // Убираем из выбранных, если уже выбрано
    } else {
      setSelectedParameters([...selectedParameters, paramId]); // Добавляем к выбранным, если не выбрано
    }
  };
  
const fetchDictionaryParameters = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/DictionaryParameters`);
    const data = await response.json();
    setExistingParameters(data);
  } catch (error) {
    console.error('Ошибка при получении параметров из словаря:', error);
  }
};
 // Обработка выбора файла
 const handleFileChange = (event) => {
  setSelectedFile(event.target.files[0]);
};

// Отправка файла на сервер
const handleFileUpload = async () => {
  if (!selectedFile) {
    alert("Пожалуйста, выберите файл для загрузки.");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("file", selectedFile); // Имя параметра должно совпадать с ожидаемым на сервере

    // Отправка POST запроса на сервер с файлом
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/Agent/${agentId}/json`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    alert("Файл успешно загружен.");
  } catch (error) {
    console.error("Ошибка при загрузке файла:", error);
    alert("Произошла ошибка при загрузке файла.");
  }
};
const handleRemoveParameter = (index) => {
  const updatedParams = [...agentData.agentParameters];
  updatedParams.splice(index, 1);
  setAgentData({ ...agentData, agentParameters: updatedParams });
};

  // Получение списка workflow при монтировании компонента
  useEffect(() => {
    const fetchWorkflows = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/WorkFlow`);
        setWorkflows(response.data);
      } catch (error) {
        console.error("Ошибка при получении workflow:", error);
      }
    };
    fetchWorkflows();
  }, []);

  const handleWorkflowSelect = (workflowId) => {
    const updatedWorkflows = new Set(selectedWorkflows);
    if (updatedWorkflows.has(workflowId)) {
      updatedWorkflows.delete(workflowId);
    } else {
      updatedWorkflows.add(workflowId);
    }
    setSelectedWorkflows(updatedWorkflows);
  };
  // Функция для отправки workflow в RabbitMQ по id агенту
const sendWorkflowsToRabbit = () => {
  // Преобразуем Set в массив
  const selectedWorkflowsArray = Array.from(selectedWorkflows);

  // Проверяем, что у нас есть хотя бы один workflow для отправки
  if (selectedWorkflowsArray.length === 0) {
    console.error('Нет прикреплённых workflow для отправки');
    return;
  }

  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Workflows/${agentId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(selectedWorkflowsArray),
  })
    .then((response) => {
      if (response.ok) {
        console.log('Workflows sent to RabbitMQ successfully!');
      } else {
        console.error('Error sending workflows to RabbitMQ');
      }
    })
    .catch((error) => console.error('Error sending workflows to RabbitMQ:', error));
};

  const saveAgentWorkflows = () => {
    // Преобразуем Set в массив и отправляем на бэкэнд
    const selectedWorkflowsArray = Array.from(selectedWorkflows);
    
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/agents/${agentId}/workflows`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ workflowIds: selectedWorkflowsArray }),
    })
      .then((response) => {
        if (response.ok) {
          console.log('Agent workflows saved successfully!');
        } else {
          console.error('Error saving agent workflows');
        }
      })
      .catch((error) => console.error('Error saving agent workflows:', error));
  };
  
// Вызов при открытии модального окна
useEffect(() => {
  if (showParamModal) {
    fetchDictionaryParameters();
  }
}, [showParamModal]);


  const handleParamValueChange = (e, index) => {
    const updatedParameters = [...agentData.agentParameters];
    updatedParameters[index].value = e.target.value; // Изменяем значение
  
    setAgentData({
      ...agentData,
      agentParameters: updatedParameters
    });
  };
  const saveAgentParameters = () => {
    const updatedAgentData = {
      ...agentData,
      agentParameters: agentData.agentParameters.map(param => ({
        dictionaryId: param.id,
        value: param.value
      })),
      quantity: parseInt(quantity, 10),
      nodeId: agentData.nodeId
    };
  
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Agents/${agentId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedAgentData),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Ошибка обновления данных агента');
        }
        return response.json();
      })
      .then((data) => {
        setAgentData(data); // Обновляем данные агента
      })
      .catch(error => console.error('Ошибка обновления параметров:', error));
  };
  const handleSaveParameters = () => {
    const selectedParamObjects = existingParameters.filter(param =>
      selectedParameters.includes(param.id)
    );
  
    const updatedAgentParameters = [
      ...agentData.agentParameters,
      ...selectedParamObjects.map(param => ({
        id: param.id,
        name: param.name,
        unit: param.unit,
        value: '',  // Пользователь указывает значение позже
        description: param.description,
      }))
    ];
  
    setAgentData({
      ...agentData,
      agentParameters: updatedAgentParameters
    });
  
    setShowParamModal(false);  // Закрыть модальное окно
    setSelectedParameters([]); // Очистить выбранные параметры
  };
  const handleCreateAgent = () => {
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/AgentMessages/send/${agentId}`)
      .then(response => {
        console.log('Agent creation request sent successfully.');
        
        // Show the notification when the request is successful
        setShowNotification(true);

        // Hide the notification after 3 seconds
        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      })
      .catch(error => {
        console.error('Error sending agent creation request:', error);
      });
  };
  

  // Логика создания подветки
  const handleCreateSubBranch = async () => {
    if (newBranchName.trim() === '') {
      alert('Введите имя ветки.');
      return;
    }
    const payload = {
      name: newBranchName,
      parentId: selectedNode ? selectedNode.id : null,
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Node`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error('Ошибка создания ветки');
      }
      await response.json();
      setNewBranchName('');
      setShowCreateModal(false);
      await new Promise((resolve) => setTimeout(resolve, 500));
      await fetchTreeData();
    } catch (error) {
      console.error('Ошибка создания ветки:', error);
    }
  };

  // Логика удаления ветки
  const handleDeleteBranch = () => {
    if (!selectedNode) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Node/${selectedNode.id}`, {
      method: 'DELETE',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ошибка удаления ветки');
        }
        alert('Ветка удалена');
        setShowDeleteModal(false);
        fetchTreeData();
        refreshTree(); // Обновляем дерево
      })
      .catch((error) => console.error('Ошибка удаления ветки', error));
  };
  const handleCreateNewAgentForBranch = async () => {
    console.log('Selected OKPs:', selectedOkps);
    const selectedParamObjects = existingParameters.filter(param =>
      selectedParameters.includes(param.id)
    );
  
    const agentParameters = selectedParamObjects.map(param => ({
      dictionaryId: param.id,
      value: '', // Пользователь может указать значение позже
    }));
  
    const newAgent = {
      name: newName,
      quantity: parseInt(quantity, 10),
      isAgent: false,
      nodeId: selectedNode.id, // Привязываем к выбранной ветке
      okPs: selectedOkps.map(okp => ({
        id: okp.id,
        name: okp.name,
      })), // Массив выбранных ОКП
      agentParameters,
    };
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/Agents`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newAgent),
      });
  
      if (!response.ok) {
        throw new Error('Ошибка при создании агента');
      }
  
      const createdAgent = await response.json();
      console.log('Агент успешно создан:', createdAgent);
      setNewName('');
      setQuantity(1);
      setSelectedParameters([]);
      refreshTree(); // Обновляем дерево
    } catch (error) {
      console.error('Ошибка создания агента:', error);
    }
  };
  const handleQuantityChange = (e) => setQuantity(e.target.value);

  return (
    <div className="agent-details">
      <div className="tabs">
        {selectedNode && !agentId && (
          <>
            <button onClick={() => setActiveTab('treeSettings')}>Настройка дерева</button>
          </>
        )}
        {agentId && (
          <>
          <button
            className={activeTab === 'agentInfo' ? 'active' : ''}
            onClick={() => setActiveTab('agentInfo')}
          >
            Информация об агенте
          </button>       
          <button
            className={activeTab === 'processSettings' ? 'active' : ''}
            onClick={() => setActiveTab('processSettings')}
          >
            Настройка техпроцесса
          </button>
          <button
            className={activeTab === 'workflowSettings' ? 'active' : ''}
            onClick={() => setActiveTab('workflowSettings')}
          >
            Настройка Workflow
          </button>
          <button onClick={() => { handleCreateAgent(true); downloadArchive(); }}>Создать агента</button>
          <button onClick={downloadArchive}>Скачать архив</button>
        </>
        )}
      </div>
  
      {/* Вкладка Настройка дерева */}
      {activeTab === 'treeSettings' && selectedNode && (
        <div>
        <h2>{selectedNode.name}</h2>
        <div className="branch-actions">
          <button onClick={() => setShowCreateModal(true)}>Создать подветку</button>
          <button onClick={() => setShowDeleteModal(true)}>Удалить ветку</button>
        </div>
    
        {/* Форма создания нового агента */}
        <div className="agent-creation">
          <h3>Создать нового агента</h3>
          <label>
            Имя агента:
            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Введите имя агента"
            />
          </label>
          <label>
            Количество:
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              min="1"
              placeholder="Введите количество"
            />
          </label>
          <label>
           <strong>ОКП:</strong>
           <button onClick={() => setShowOkpModal(true)}>Выбрать ОКП</button>
          </label>
    
          {/* Список параметров для выбора */}
          <div>
            <h4>Выберите параметры для агента:</h4>
            <div className="parameters-scroll">
              <table className="parameters-table">
                <thead>
                  <tr>
                    <th>Имя параметра</th>
                    <th>Единица измерения</th>
                    <th>Описание</th>
                    <th>Выбор</th>
                  </tr>
                </thead>
                <tbody>
                  {existingParameters.map((param) => (
                    <tr key={param.id}>
                      <td>{param.name}</td>
                      <td>{param.unit}</td>
                      <td>{param.description}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedParameters.includes(param.id)}
                          onChange={() => handleParameterSelection(param.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
           
          <button className="button" onClick={handleCreateNewAgentForBranch}>Создать агента</button>
        </div>
      </div>
    )}
    
  
    {activeTab === 'processSettings' && agentData && (
  <div>
    <h2>Настройка техпроцесса</h2>
    <h2>{agentData.name}</h2>
    {/* Загрузка файла */}
    <div>
      <input type="file" onChange={handleFileChange} />
      <button className="button" onClick={handleFileUpload}>Загрузить файл</button>
    </div>

    {/* Ввод времени начала */}
    <div style={{ marginTop: '20px' }}>
      <label>Время начала:</label>
      <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
        <input
          type="number"
          placeholder="Год"
          value={processYear}
          onChange={(e) => setProcessYear(e.target.value)}
          style={{ width: '70px', padding: '5px' }}
        />
        <input
          type="number"
          placeholder="Месяц"
          value={processMonth}
          onChange={(e) => setProcessMonth(e.target.value)}
          style={{ width: '70px', padding: '5px' }}
        />
        <input
          type="number"
          placeholder="День"
          value={processDay}
          onChange={(e) => setProcessDay(e.target.value)}
          style={{ width: '70px', padding: '5px' }}
        />
        <input
          type="text"
          placeholder="Часы:Минуты"
          value={processTime}
          onChange={(e) => setProcessTime(e.target.value)}
          style={{ width: '100px', padding: '5px' }}
        />
      </div>
      <button className="button" onClick={sendProcess}>Отправить</button>
    </div>
  </div>
)}

  
      {/* Вкладка Настройка Workflow */}
      {activeTab === 'workflowSettings' && agentData && (
       <div>
       <h2>Настройка Workflow для агента</h2>
       <h2>{agentData.name}</h2>
       <table>
         <thead>
           <tr>
             <th>Выбрать</th>
             <th>Имя Workflow</th>
           </tr>
         </thead>
         <tbody>
           {workflows.map((wf) => (
             <tr key={wf.id}>
               <td>
                 <input
                   type="checkbox"
                   checked={selectedWorkflows.has(wf.id)}
                   onChange={() => handleWorkflowSelect(wf.id)}
                 />
               </td>
               <td>{wf.name}</td>
             </tr>
           ))}
         </tbody>
       </table>
       <button className="button" onClick={saveAgentWorkflows}>Сохранить</button>
       <button className="button" onClick={sendWorkflowsToRabbit}>Отправить в RabbitMQ</button>
     </div>
      )}  
      {/* Информация об агенте */}
      {activeTab === 'agentInfo' && agentData && (
        <div>
          <h2>{agentData.name}</h2>
          <div style={{ marginTop: "20px" }}>
             <h3>Атрибуты агента</h3>
             <p><strong>Номер очереди:</strong> {queueNumber || "Нет данных"}</p>
          </div>
          <p><strong>ОКП:</strong> </p>
          {agentData.okPs && agentData.okPs.length > 0 ? (
          <ul>
             {agentData.okPs.map((okp, index) => (
               <li key={index}>{okp.name}</li>
             ))}
           </ul>
           ) : (
            <p>ОКП не указано</p>
          )}
          <button className="button" onClick={() => setShowOkpModal(true)}>Выбрать ОКП</button>
          <div className="quantity-input">
            <label>
              <strong>Quantity:</strong>
              <input
                type="number"
                value={quantity}
                onChange={handleQuantityChange}
                min="1"
              />
            </label>
          </div> 
           {/* Таблица для отображения параметров агента */}
        <h3>Agent Parameters:</h3>
        <button className="button" onClick={() => setShowParamModal(true)}>+ Добавить параметр</button>
        <table className="agent-parameters-table">
          <thead>
            <tr>
              <th>Parameters Name</th>
              <th>Attribute</th>
              <th>Value</th>
              <th>Description</th>
              <th>Action</th> {/* Новый столбец для действий */}
            </tr>
          </thead>
          <tbody>
            {agentData.agentParameters.map((param, index) => (
              <tr key={param.id}>
                <td>{param.name}</td>
                <td>{param.unit}</td>
                <td>
                  <input
                    type="text"
                    value={param.value}
                    onChange={(e) => handleParamValueChange(e, index)}
                  />
                </td>
                <td>{param.description}</td>
                <td>
                  <button onClick={() => handleRemoveParameter(index)} className="remove-button">
                    &times; {/* Крестик для удаления */}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="button" onClick={saveAgentParameters}>
  Сохранить параметры
</button>
<button
  className="button danger"
  onClick={deleteAgent}
  style={{ marginTop: '20px' }}
>
  Delete Agent
</button>

      </div>
    )}
  
      {/* Модальные окна */}
      {showCreateModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Создание Подветки</h3>
            <input
              type="text"
              value={newBranchName}
              onChange={(e) => setNewBranchName(e.target.value)}
              placeholder="Введите название подветки"
            />
            <div className="modal-actions">
            <button className="button" onClick={handleCreateSubBranch}>Сохранить</button>
            <button className="button" onClick={() => setShowCreateModal(false)}>Отмена</button>
            </div>
          </div>
        </div>
      )}
  
      {showDeleteModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Удаление Ветки</h3>
            <p>Вы уверены, что хотите удалить ветку {selectedNode.name}?</p>
            <div className="modal-actions">
              <button onClick={handleDeleteBranch}>Удалить</button>
              <button onClick={() => setShowDeleteModal(false)}>Отмена</button>
            </div>
          </div>
        </div>
      )}
  
  {showParamModal && (
  <div className="modal">
    <div className="modal-content">
      <h3>Добавить параметры</h3>

      {/* Список существующих параметров с чекбоксами */}
      <div className="existing-parameters">
        <h4>Существующие параметры:</h4>
        <div className="parameters-scroll">
          <table className="parameters-table">
            <thead>
              <tr>
                <th>Имя параметра</th>
                <th>Единица измерения</th>
                <th>Описание</th>
                <th>Выбор</th>
              </tr>
            </thead>
            <tbody>
              {existingParameters.map((param) => (
                <tr key={param.id}>
                  <td>{param.name}</td>
                  <td>{param.unit}</td>
                  <td>{param.description}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedParameters.includes(param.id)}
                      onChange={() => handleParameterSelection(param.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Форма для создания нового параметра */}
      <h4>Создать новый параметр:</h4>
      <input
        type="text"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        placeholder="Attribute Name"
      />
      <input
        type="text"
        value={newDescription}
        onChange={(e) => setNewDescription(e.target.value)}
        placeholder="Description"
      />
      <input
        type="text"
        value={newType}
        onChange={(e) => setNewType(e.target.value)}
        placeholder="Type (например, string)"
      />
      <input
        type="text"
        value={newUnit}
        onChange={(e) => setNewUnit(e.target.value)}
        placeholder="Unit (например, Вт)"
      />
      <button className="button" onClick={handleAddNewParameter}>
  Сохранить параметр в словарь
</button>

      {/* Кнопки сохранения или отмены */}
      <div className="modal-actions">
      <button className="button" onClick={handleSaveParameters}>
  Сохранить выбранные параметры
</button>
<button className="button" onClick={() => setShowParamModal(false)}>
  Отмена
</button>
      </div>
    </div>
  </div>
)}
      {/* Notification component */}
      {showNotification && (
        <div className={`notification ${showNotification ? 'show' : 'hide'}`}>
          Агент {agentName} создан!
        </div>
      )}
{showOkpModal && (
  <div className="modal">
    <div className="modal-content">
      <h3>Выберите ОКП</h3>
      <div className="okp-selection">
        <table className="okp-table">
          <thead>
            <tr>
              <th>Имя ОКП</th>
              <th>Описание</th>
              <th>Выбор</th>
            </tr>
          </thead>
          <tbody>
            {existingOkps.map((okp) => (
              <tr key={okp.id}>
                <td>{okp.name}</td>
                <td>{okp.description}</td> {/* Добавлено описание */}
                <td>
                  <input
                    type="checkbox"
                    checked={selectedOkps.some(selected => selected.id === okp.id)} // Проверяем наличие объекта с таким же id
                    onChange={() => handleOkpSelection(okp.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="modal-actions">
        <button onClick={() => setShowOkpModal(false)}>Отмена</button>
        <button onClick={handleSaveSelectedOkps}>Сохранить</button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default AgentDetails;
